import React from "react";
import { Container } from "react-bootstrap";
import dedicated from "../../../../Asset/hero-hire-dedicated-hero-developers.svg";

const Second = () => {
  return (
    <>
      <section
        className="side-image-box-section"
        style={{ backgroundColor: "var(--white-color)" }}
      >
        <Container>
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-12 order-2 order-md-2">
              <div className="info-content">
                <p>
                  Our group will assist you by giving the best ability and skill
                  that can help you with projects that satisfy the needs of your
                  ventures. We look for candidates who are passionate about
                  working on the latest cutting edge technologies, have a strong
                  work ethic, and are eager to learn.
                </p>
                <p>
                  Codeffi brings together a. committed and tight-knit team of
                  developers and designers, focused on implementing the latest
                  technologies to create lean workflows with maximum
                  productivity, who works with great minds and solve problems
                  for individuals, businesses and developers.
                </p>
                <ul className="check-list count_2 pt-4">
                  <li>Web developers</li>
                  <li>Android Developer</li>
                  <li>iOS Developer</li>
                  <li>AI Developer</li>
                  <li>IoT Engineer</li>
                  <li>Software Developer</li>
                  <li>UI / UX Designer</li>
                </ul>
                <p className="mt-4">
                  Our dedicated team of developers has made us one of the most
                  sought after companies in the industry, and we’re always on
                  the lookout for new talent to join our ranks.
                </p>
              </div>
            </div>
            <div className="col-xl-6 col-lg-12 order-1 order-md-1">
              <div className="info-img">
                <img alt="infoImage" src={dedicated} className="w-100" />
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Second;
